import createLogger from '../src/utils/Logger'
import * as Sentry from '@sentry/browser'
import Vue from 'vue'

// const isProduction = process.env.NODE_ENV === 'production'
const isProduction = false

const SentryInstance = isProduction
  ? Sentry.init({
    dsn: process.env.SENTRY_DSN,
    environment: process.env.DEPLOY_ENV,
    integrations: [new Sentry.Integrations.Vue({ Vue })]
  })
  : {}

const getContext = () => ({})

export const loggerInstance = createLogger(SentryInstance, getContext, isProduction)

export const appLogger = {
  install (Vue, options) {
    Vue.prototype.$logger = loggerInstance
  }
}

function createStoreLogger (loggerInstance) {
  return store => {
    store.$logger = loggerInstance
  }
}

export const storeLogger = createStoreLogger(loggerInstance)



//////////////////
// WEBPACK FOOTER
// ./plugins/logger.js
// module id = null
// module chunks = 